<div class="row">

  <div class="col-md-6">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-header text-center">
        <h3 class="box-title ">Classes Equipamentos Cadastradas</h3><br />
        <span class="text-muted">Selecione para editar</span>
        <div class="divider"></div>

      </div>

      <div class="box-body">


        <div class="box-table" style="height: 440px; border: 1px solid #ddd; ">
          <table>
            <thead>
              <tr>
                <th class="text-center"><i *ngIf="this.isLoading"
                    class="fa fa-spinner fa-spin fa-fw pull-left"></i>Classe Equipamento</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of cadastrados" class="cp" (click)="getById(c.id)"
                [ngClass]="{'tr-info': c.id == this.form.get('id').value}">
                <td class="text-center">{{ c.descricao }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="box-footer">
        <section *ngIf="this.cadastrados?.length > 0">
          <span class="pl-1">Total Classes Equipamento : <b>{{ this.cadastrados?.length }}</b>
          </span>
          <span *ngIf="this.isFiltered" class="pl-3 text-primary">(filtrados)</span>
        </section>
        <section *ngIf="this.cadastrados?.length == 0">
          <span class="pl-1"><b>Nenhum resultado</b> </span>
        </section>
      </div>
    </div>
  </div>




  <div class="col-md-6">

    <div class="box bord" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }"
      style="height: 618px;">

      <div class="box-body" >


        <form novalidate style="padding-top: 40px;" [formGroup]="form" id="form" (validSubmit)="submit()">



          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="position-relative form-group">
                <label for="">Classe Equipamento</label>
                <input class="form-control" formControlName="descricao" type="text" maxlength="100" required>
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('descricao').hasError('isNotUniqueDescricao')">Esta descrição já esta em
                    uso</small>
                </section>
              </div>
            </div>
          </div>


        </form>
      </div>
      <div class="text-center">
        <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
      </div>
    </div>
  </div>
</div>

<div class="row mt-3">
  <div class="col-md-12">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
            <div class="d-flex justify-content-start">
              <button type="button" class="btn btn-light pl-3 pr-3 mr-3"
                [disabled]="!(this.isEditing && this.autorizacoes?.podeExcluir)" title="Exluir Local selecionado"
                (click)="questionDelete(this.form.get('id').value)">
                <span class="text-danger"><i class="fa fa-trash"></i></span><span class="pl-3">Excluir</span>
              </button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-4">

            <div class="d-flex justify-content-end">

              <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="reset()">Limpar</button>
              <button type="submit" class="btn pl-5 pr-5 mr-3 btn-shadow" form="form"
                [disabled]="(!(!this.isEditing && this.autorizacoes?.podeIncluir) && !(this.isEditing && this.autorizacoes?.podeAlterar))"
                [ngClass]="{'btn-primary': !this.isEditing, 'btn-warning': this.isEditing }">
                <span *ngIf="!this.isEditing">Cadastrar</span>
                <span *ngIf="this.isEditing">Editar</span>
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>